import '@/css/rich-text-editor.css';

interface RichTextDisplayProps {
  content?: string; // HTML string to display
  className?: string; // Additional CSS classes
}

export default function RichTextDisplay({
  content,
  className = ''
}: RichTextDisplayProps) {
  return (
    <div 
      className={`rich-text-display ${className} `}
      dangerouslySetInnerHTML={{ __html: content || '' }}
    />
  );
}
